import Vue, {Component} from 'vue'
import {CrudCollection} from '@hc/graphql'
import {formatCurrency, formatDate, formatDatetime} from '@hc/graphql'
import _ from 'lodash'

// ag-grid's vue 2 adapter passes the cell params as instance data (`data: {params}`) instead of props.
// This wrapper forwards them as the `params` prop, so cell renderers can use <script setup> with defineProps.
export function cellRendererComponent(component: Component) {
  return Vue.extend({
    data: () => ({ params: null }),
    render(h) {
      return h(component, { props: { params: this.params } })
    }
  })
}

export const Helper = {
  checkboxSelection: function(params) {
    try {
      const displayedColumns = params.columnApi.getAllDisplayedColumns()
      return displayedColumns[0] === params.column
    } catch(e){
      console.error("Error getting selected grid column")
      console.error(e)
    }
    return false
  },
}

export const Renderer = {
  date: (data) => {
    if(!data.value) return null
    return formatDate(data.value)
  },
  datetime: (data) => {
    if(!data.value) return null
    return formatDatetime(data.value)
  },
  aggregate: (data) => {
    if(!data.value || !data.value.aggregate) return null
    return data.value.aggregate.count
  },
  percent: (row) => {
    if(row.value == null) return
    return row.value + " %"
  },
  boolean: (row) => {
    if(row.value) return `<i class="fa fas fa-check"/>`
    else return `<i class="fa fas fa-times"/>`
  },
  empty: (row) => {
    return ''
  },
}
